module.exports = __webpack_public_path__ + "static/pic010-27319622eedad3760117a610126ac818.jpg";